module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-oyster-fluted-balmoral-1.c418fadc.jpg";